module.exports = __webpack_public_path__ + "img/1599101009573.05896d45.png";